import React from "react";
import { useParams } from "react-router-dom";

// functions
import { getArticle } from "../../Data";

import { Wrapper, Content } from "./Article.styles";

const Article = () => {
  const { title } = useParams();
  const article = getArticle(title);
  return (
    <Wrapper>
      <Content>
        <h1>{article.title}</h1>
        <p className="stack">{article.stack}</p>
        <p className="description">{article.description}</p>
        <p className="text">{article.text}</p>
      </Content>
    </Wrapper>
  );
};

export default Article;
